import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  TextField,
  Checkbox,
  FormControlLabel,
  Divider,
  Grid,
  Tooltip,
  Paper,
} from "@mui/material";
import { Add, Settings, Info, Close } from "@mui/icons-material";
import MDButton from "components/MDButton";
import { get, post } from "requests";
import EditStipulationDetailsComponent from "./EditStipulationDetailsComponent";
import MDBox from "../../../../components/MDBox";

interface ManageStipulationComponentProps {
  showManageStips: boolean;
  setShowManageStips: (show: boolean) => void;
  refreshAppStipulation: () => void;
}

interface Stipulation {
  id: number;
  type: string;
  default: boolean;
}

const ManageStipulationComponent: React.FC<ManageStipulationComponentProps> = ({
  showManageStips,
  setShowManageStips,
  refreshAppStipulation,
}) => {
  const [allStips, setAllStips] = useState<Stipulation[]>([]);
  const [addStipRequest, setAddStipRequest] = useState({ stipulationType: "", isDefault: false });
  const [showAdd, setShowAdd] = useState(false);
  console.log("allStips", allStips);

  useEffect(() => {
    getAllStips();
  }, []);

  const getAllStips = () => {
    get("stipulations").then((response) => {
      setAllStips(response);
    });
  };

  const addNewStip = () => {
    if (!addStipRequest.stipulationType) {
      alert("Stipulation type cannot be empty.");
      return;
    }
    post("stipulations/addStipulation", addStipRequest).then(() => {
      setAddStipRequest({ stipulationType: "", isDefault: false });
      getAllStips();
      setShowAdd(false);
    });
  };

  const resetModal = () => {
    setShowManageStips(false);
    setAddStipRequest({ stipulationType: "", isDefault: false });
    refreshAppStipulation();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setAddStipRequest((prevState) => ({
      ...prevState,
      stipulationType: value,
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setAddStipRequest((prevState) => ({
      ...prevState,
      isDefault: checked,
    }));
  };

  const addStipModal = (
    <div style={{ marginLeft: "2%", marginRight: "2%" }}>
      <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
        {showAdd && (
          <Close
            color="secondary"
            onClick={() => {
              setShowAdd(false);
              setAddStipRequest({ stipulationType: "", isDefault: false });
            }}
          />
        )}
      </div>
      <TextField
        style={{ marginTop: "5px" }}
        label="Type"
        type="text"
        onChange={handleInputChange}
        name="stipulationType"
        fullWidth
        margin="normal"
        inputProps={{ style: { fontSize: 15 } }}
        InputLabelProps={{ style: { fontSize: 14 } }}
      />
      <FormControlLabel
        style={{ marginTop: "15px" }}
        control={
          <Checkbox
            checked={addStipRequest.isDefault}
            onChange={handleCheckboxChange}
            name="isDefault"
          />
        }
        label={
          <div style={{ display: "flex" }}>
            <Typography style={{ fontSize: "15px" }}>Default Stipulation</Typography>
            <Tooltip
              title={
                <Typography style={{ fontSize: "15px" }}>
                  Default Stipulation Type will be automatically included during new application
                  creation.
                </Typography>
              }
            >
              <Info style={{ fontSize: "15px", color: "grey", marginRight: "10px" }} />
            </Tooltip>
          </div>
        }
      />
      <div style={{ marginTop: "3px" }} className={"add-stipulation-modal-button"}>
        <MDButton color="primary" variant="contained" onClick={addNewStip}>
          Add
        </MDButton>
      </div>
      <Divider style={{ marginTop: "5px", height: "1.25px" }} />
    </div>
  );

  const editStipModal = (
    <Grid
      container
      style={{ marginTop: "8px", maxHeight: "600px", overflowY: "auto", overflowX: "hidden" }}
    >
      {/* Header Row */}
      <Grid container item>
        <Grid item style={{ width: "65%" }}>
          <Typography
            variant="body1"
            style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
          >
            Type
          </Typography>
        </Grid>
        <Grid item style={{ width: "20%" }}>
          <Typography
            variant="body1"
            style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
          >
            Is Default
          </Typography>
        </Grid>
        <Grid item style={{ width: "15%" }}>
          <Typography
            variant="body1"
            style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
          >
            Actions
          </Typography>
        </Grid>
      </Grid>

      {/* Data Rows */}
      {allStips.map((stip) => (
        <React.Fragment key={stip.id}>
          <EditStipulationDetailsComponent stip={stip} getAllStips={getAllStips} />
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );

  return (
    <Dialog open={showManageStips} onClose={resetModal} maxWidth="md" fullWidth>
      <DialogTitle>
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDBox display="flex" alignItems="center">
            <Settings sx={{ mr: 1 }} />
            <Typography variant="h5">MANAGE STIPULATIONS</Typography>
          </MDBox>
        </MDBox>
      </DialogTitle>

      <DialogContent style={{ paddingTop: 0 }}>
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          {!showAdd && (
            <Tooltip title="Add New">
              <IconButton onClick={() => setShowAdd(true)}>
                <Add style={{ fontSize: "25px", fontWeight: "bold", cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
        <div style={{ marginTop: "10px" }}>
          {showAdd && addStipModal}
          {editStipModal}
        </div>
      </DialogContent>

      <DialogActions>
        <MDButton
          color="error"
          variant="contained"
          onClick={resetModal}
          style={{ marginRight: "10px" }}
        >
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default ManageStipulationComponent;
